if (!window.cip_SendSmsCodeDialog) {
    window.cip_SendSmsCodeDialog = {};
}

(function () {
	"use strict";

	cip_SendSmsCodeDialog.okText = "Send SMS Activation Code";
	
	cip_SendSmsCodeDialog.id = function () {
		return 'showSendSmsCodeDialog';
	};
	
	cip_SendSmsCodeDialog.title = function () {
		return 'Acipess';
	};
	
	cip_SendSmsCodeDialog.width = function () {
		return 450;
	};
	
	cip_SendSmsCodeDialog.content = function (data) {
		return 	"<p>" +
					"We need to send you a secure activation code. The activation code will be sent to your mobile phone (" + data.maskedMobilePhoneNumber + ").<br><br>" + 
					"Press 'Send SMS Activation Code' to continue" +
			  "</p>";
	};	
}());